import { Button, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "./../../../../../utils/formatDinero"
import { obtenerHabitacionesAction, addItemsAction, resetPenalizacionAction } from "./../../../../../ducks/cambioPaqueteDuck"
import { ToastMessage } from "./../../../../../global/ToastMessage"
const FieldHabitacion = () => {
    const { listaHabitaciones, paquete, cantidadPasajeros, listaItems, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const dispatch = useDispatch()
    const [editar, setEditar] = useState(false)
    const [value, setValue] = useState(1)
    const [selectValue, setSelectValue] = useState("0")
    useEffect(() => {
        dispatch(obtenerHabitacionesAction({ ClavePaquete: clavePaquete }))
    }, [dispatch, clavePaquete])

    const handleChangeValue = (event) => {

        if (Number(event.target.value) <= 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de suplmentos debe ser mayor o igaul a 1",
            })
            return null
        }

        setValue(event.target.value)
    }
    const handleChangeSelectValue = (event) => {
        setSelectValue(event.target.value)
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const handleClickSave = () => {
        const supHabitacion = listaHabitaciones.find(plaza => plaza.IdExtraPaqueteProveedor === parseInt(selectValue))

        if (!supHabitacion) {
            ToastMessage.fire({
                icon: "info",
                title: "Seleccione un suplmento de habitacion",
            })
            return null
        }

        if (Number(value) <= 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de suplmentos debe ser mayor o igaul a 1",
            })
            return null
        }

        if (supHabitacion.Descripcion === "Sencilla" && cantidadPasajeros !== 1) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede asignar una plaza Sencilla si hay mas de un pasajero",
            })
            return null
        }

        if (supHabitacion.Descripcion === "Compartida" && cantidadPasajeros !== 1) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede asignar una plaza Compartida si hay mas de un pasajero",
            })
            return null
        }

        if (listaItems.find(item => item.name === "Sencilla")) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede agregar mas plazas",
            })
            return null
        }

        if (listaItems.find(item => item.name === "Compartida")) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede agregar mas plazas",
            })
            return null
        }

        const plazaItem = listaItems.find(item => item.name === supHabitacion.Descripcion)
        let arraItems = [...listaItems]

        if (plazaItem) {
            arraItems = arraItems.filter(item => item.id !== supHabitacion.IdObjeto)
        }

        let itemHabitacion = {
            id: supHabitacion.IdObjeto,
            name: `${supHabitacion.Descripcion}`,
            price: supHabitacion.Suplemento,
            currency: paquete.Moneda?.Clave,
            type: "PLAZA",
            quantity: value
        }

        arraItems.push(itemHabitacion)

        // if (supHabitacion.Descripcion === "Menor e infante") {
        //     arraItems = arraItems.map(item => {
        //         if (item.type === "SALIDA" || item.type === "EXTRA")
        //             return {...item, quantity: Number(cantidadPasajeros) + Number(value)  }
        //         return item
        //     })
        // }
        dispatch(addItemsAction({ listaItem: arraItems }))
        dispatch(resetPenalizacionAction())
        setEditar(false)
    }
    return <div style={{ margin: "2% 0" }}>
        <Grid container >
            <Grid item xs={12}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "100%" }}>
                        <FormControl variant="outlined" style={{ width: "100%" }}>
                            <InputLabel id="lPlazas">Plazas</InputLabel>
                            <Select
                                disabled={!editar || clavePaquete === "0"}
                                labelId="lPlazas"
                                id="SPlazas"
                                name="SPlazas"
                                onChange={handleChangeSelectValue}
                                label="Plazas"
                                value={selectValue}
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {listaHabitaciones.map((plaza, index) => (
                                    <MenuItem key={index} value={`${plaza.IdExtraPaqueteProveedor}`}>
                                        {`${plaza.Nombre} (${formatDinero(plaza.Suplemento)})`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ width: "100%" }}>
                        <TextField
                            value={value}
                            disabled={!editar || clavePaquete === "0"}
                            style={{ width: "100%" }}
                            id="outlined-number-Cantidad-plazas"
                            label="Cantidad"
                            type={!editar ? "text" : "number"}
                            onChange={handleChangeValue}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                    </div>

                    {
                        (!editar) &&
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="primary"
                            onClick={hangdleClickEditar}
                            disabled={clavePaquete === "0"}
                        >
                            Editar
                        </Button>
                    }
                    {
                        (editar) &&
                        <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={handleClickSave}
                                disabled={clavePaquete === "0" || selectValue === "0"}
                            >
                                Guardar
                            </Button>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="default"
                                onClick={hangdleClickEditar}
                            >
                                Cancelar
                            </Button>
                        </div>
                    }
                </div>
            </Grid>
        </Grid>
    </div>
}
export default FieldHabitacion